// extracted by mini-css-extract-plugin
module.exports = {"courseList":"coursetable_courseList__3TslF","courseTable":"coursetable_courseTable__3ekgT","credits":"coursetable_credits__-LL6s","tableBody":"coursetable_tableBody__28xmU"};